import styled, { css } from 'styled-components';

import { iconFill } from '../../../../styles/mixin';
import { Icon } from '../../../Icon';

interface ISortIndicator {
    isSorted: boolean;
    isSortedAsc: boolean;
}

export const Indicator = styled(Icon)<ISortIndicator>`
    cursor: pointer;
    width: 0.375rem;
    margin-top: -0.25rem;
    margin-left: 0.5rem;
    transition: all ${({ theme }) => theme.transitions.hover};
    ${({ isSorted, isSortedAsc }) => {
        return css`
            transform: rotate(${isSortedAsc ? -180 : 0}deg)
                scale(${isSorted || isSortedAsc ? 1.2 : 1});
            ${iconFill(
                isSorted || isSortedAsc ? '#636363' : 'rgba(99,99,99,0.29)'
            )}
        `;
    }};
`;
